import { PersonRequest } from "@plinknz/tah-website-elements";

import { AddressMeta } from "../../../components/form/address-finder-input";
import { ADDRESS_FINDER_KEY } from "../../../components/survey-widgets/address-finder-widget";
import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export interface PersonalData {
    phone: string;
    email: string;
    addressfinder: AddressMeta;
}

interface PersonalDetailsConfigParams {
    member: PersonRequest;
    children: {
        id: number;
        firstName: string;
        surname: string;
    }[];
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function collapseSurrogate(data: any) {
    const id = data.memberChooser;
    if (!id) {
        return data;
    }

    return {
        ...data,
        firstName: data[`firstName${id}`],
        surname: data[`surname${id}`],
        phone: data[`phone${id}`],
        email: data[`email${id}`],
        id,
    };
}

export function personalDetailsConfig({
    member,
    children,
}: PersonalDetailsConfigParams): PageConfig[] {
    let defaultValue;
    const hasTamariki = !!children.length;
    const childChoices = children.map(({ id, firstName, surname }) => ({
        value: id,
        text: `${firstName} ${surname}`,
    }));
    const memberName = `${member.firstName}${
        member.surname ? ` ${member.surname}` : ""
    }`;
    childChoices.unshift({ value: member.id, text: memberName });

    if (member?.address && member?.address.length) {
        const address = member?.address[0];
        defaultValue = {
            address_line_1: address.line1,
            address_line_2: address.line2,
            suburb: address.suburb,
            city: address.city,
            postcode: address.postcode,
            address: address.state,
            country: address.country,
        };
    }

    return [
        {
            name: "applicantsDetails",
            title: "Applicant's Details - Taipitopito o te Kaitono",
            questions: [
                {
                    type: "dropdown",
                    name: "applicant",
                    title: "Name",
                    isRequired: true,
                    choices: childChoices,
                    visibleIf: hasTamariki ? "true" : "false",
                },
                {
                    type: "text",
                    name: "name",
                    title: "Name",
                    placeHolder: "Ingoa",
                    defaultValue: member?.name,
                    readOnly: true,
                    isRequired: true,
                    visibleIf: hasTamariki ? "false" : "true",
                },
                {
                    type: "text",
                    title: "Phone",
                    name: "phone",
                    placeHolder: "Waea",
                    startWithNewLine: false,
                    defaultValue: member?.phone?.find(
                        (e) => e.typeId === "PH" || "PM"
                    )?.value,
                },
                {
                    type: "text",
                    name: "email",
                    title: "Email",
                    placeHolder: "Īmēra",
                    validators: [
                        {
                            type: "email",
                        },
                    ],
                    startWithNewLine: true,
                    defaultValue: member?.email?.length
                        ? member.email[0].value
                        : undefined,
                    isRequired: true,
                    readOnly: true,
                },
                {
                    type: "html",
                    title: "",
                    name: "tamaiti",
                    html: `If your child doesn't appear here, you can email
                    <a href="mailto:grants@ngatikuia.iwi.nz" target="_blank">
                        grants@ngatikuia.iwi.nz
                    </a>for them to be added to your account`,
                },
            ],
        },
        {
            name: "address",
            title: "Address - Wāhi Noho",
            questions: [
                {
                    title: "Address",
                    type: ADDRESS_FINDER_KEY,
                    name: "addressfinder",
                    isRequired: true,
                    defaultValue,
                },
            ],
        },
    ];
}
